"use client"
import { IconClose } from "@/app/(site)/_components/Atoms/Icons"
import Modal from "@/app/(site)/_components/Atoms/Modal"
import GCTextElement from "@/app/(site)/_components/GCMolecules/GCTextElement"
import { useHideGladlyIcon } from "@/app/(site)/_utils/_hooks/useHideGladlyIcon"
import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import { FOCUS_VISIBLE_CLASS } from "@/src/utils/a11y/focusVisible"
import { HIT_TARGET_CLASS } from "@/src/utils/a11y/hitTarget"
import { clsx } from "@/src/utils/clsx"
import { t } from "@/translations"

export default function TaxesInformationModal({ langCode }: { langCode: string }) {
    const { toggleTaxesInformationModal, isTaxesInformationModalOpen } =
        useEcommerceStore()

    useHideGladlyIcon(isTaxesInformationModalOpen)

    return (
        <Modal
            open={isTaxesInformationModalOpen}
            onOpenChange={() => toggleTaxesInformationModal()}
        >
            <Modal.Content
                transitionSettings="fadeInOut"
                className="flex max-h-[330px] flex-col pb-12 lg:max-h-[668px]"
            >
                <div className="flex flex-col gap-24">
                    <Modal.Title className="flex items-center justify-between">
                        <GCTextElement
                            className="Trim_Mono_POC_Text_15_130_-5_700_uppercase"
                            text={t(langCode, "checkout.taxes_information_title")}
                            as="p"
                        />
                        <Modal.Close
                            className={clsx("p-5", FOCUS_VISIBLE_CLASS, HIT_TARGET_CLASS)}
                        >
                            <IconClose className="h-10 w-10" />
                        </Modal.Close>
                    </Modal.Title>
                    <GCTextElement
                        className="Trade_Gothic_Text_14_150_0_300"
                        text={t(langCode, "checkout.taxes_information_description")}
                        as="p"
                    />
                </div>
            </Modal.Content>
        </Modal>
    )
}
